import { actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  GlobalVariables,
  jsonApiHeader,
  showErrorMessage, 
  showWarningMessage,
  showSuccessMessage,
} from './../../../../../actions/utilAction';
export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  create_post_data,
  GlobalVariables,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
  API_URL,
};

export const GET_MASTER_LOCATIONS_API = `${API_URL}/MasterLocations/GetLocations`;
export const POST_MASTER_LOCATION_API = `${API_URL}/MasterLocations/SaveLocation`;
export const GET_MASTER_LOCATION_DETAILS_API = `${API_URL}/MasterLocations/GetLocationById`;
export const DELETE_MASTER_LOCATION_API = `${API_URL}/MasterLocations/DeleteLocation`;
//export const USERLOCATIONS = `${API_URL}/Staff`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const locationMasterActionTypes = {
  get_masterdata: createRequestActionTypes('GET_MASTER_DATA'),
  get_masterLocationsList: createRequestActionTypes('GET_MASTERLOCATIONSLIST'),
  get_masterLocationDetails: createRequestActionTypes('GET_MASTERLOCATIONDETAILS'),
  post_masterLocation: createRequestActionTypes('POST_MASTERLOCATION'),
  delete_masterLocation: createRequestActionTypes('DELETE_MASTERLOCATION'),
};
export const MODULE = 'MASTER_LOCATION';



// WEBPACK FOOTER //
// ./src/modules/Masters/components/location-master/constants/ApiConstants.js